import { render } from "./SwitchLocale.vue?vue&type=template&id=45a202c6"
import script from "./SwitchLocale.vue?vue&type=script&lang=js"
export * from "./SwitchLocale.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__